import { RemovableCard, Text } from '@dixa/lib-shared-habla';
import { useEffectOnce } from 'react-use';

import {
  BulkModalActionBaseProps,
  BulkModalCancelCsatAction,
} from '../../../types/conversationsBulkModal.types';
import { conversationsBulkModalActionLabel } from '../../../utils/conversationsBulkModalActionLabel';

type ConversationsBulkModalCancelCsatActionProps =
  BulkModalActionBaseProps<BulkModalCancelCsatAction>;

/** Represents the component for the conversations bulk modal cancel CSAT action. */
export const ConversationsBulkModalCancelCsatAction = ({
  conversationIds,
  onRemove,
  onChange,
}: ConversationsBulkModalCancelCsatActionProps): JSX.Element => {
  useEffectOnce(() => {
    onChange({
      type: 'cancel_csat',
      isValid: true,
      arg: { csids: conversationIds },
    });
  });

  return (
    <RemovableCard
      icon="close"
      title={conversationsBulkModalActionLabel['cancel_csat']}
      onRemove={() => onRemove('cancel_csat')}
    >
      <Text.Paragraph subdued>
        Please note that, once CSAT has been cancelled it cannot be reinstated.
        Please select this option only if you are sure you would like to cancel
        CSAT for the selected conversations. If selected conversations are not
        eligible for CSAT, they will not be affected.
      </Text.Paragraph>
    </RemovableCard>
  );
};
